import { createContext, useState } from "react";
import { useEffect } from 'react';

const SearchableInputContext = createContext({
  options: null,
  setOptions: () => {},
  value: null,
  setValue: () => {},
  selectedOption: null,
  setSelectedOption: () => {},
  isOpen: false,
  setIsOpen: () => {},
  isSearchModalOpen: false,
  setIsSearchModalOpen: () => {},
  toggleSearchModal: () => {},

});

export const SearchableInputProvider = (props) => {
  const [options, setOptions] = useState(null);
  const [value, setValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const toggleSearchModal = () => {
    setIsSearchModalOpen((prev) => !prev);
  };

  // Add keyboard shortcut handler
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Ctrl+K or Command+K (Mac)
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault(); // Prevent default browser behavior
        toggleSearchModal();
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);
    
    // Clean up
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const context = {
    options,
    setOptions,
    value,
    setValue,
    selectedOption,
    setSelectedOption,
    isOpen,
    setIsOpen,
    isSearchModalOpen,
    setIsSearchModalOpen,
    toggleSearchModal,
  };

  return (
    <SearchableInputContext.Provider value={context}>
      {props.children}
    </SearchableInputContext.Provider>
  );
};

export default SearchableInputContext;
